import React, { Component } from "react";
import { Form, Button, Col, Row, Icon, Tooltip, Drawer, Modal, message, Divider, Upload } from "antd";
import axios from "axios";
import Colors from '../utils/Colors';
import InputForm from "./InputForm";
import { resolveImageUrl } from '../utils/Storage';
// import { getUsuario } from "../utils/LoginManager";
// import moment from "moment-timezone";

const { Item: ItemForm } = Form;

function getBase64(img, callback) {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
}

function beforeUpload(file) {
    const isJpgOrPng = file.type === 'text/html';
    if (!isJpgOrPng) {
        message.error('Você só pode enviar arquivos HTML');
    }
    const isLt2M = file.size / 1024 / 1024 < 0.1;
    if (!isLt2M) {
        message.error('A imagem deve ter menos de 100 KB!');
    }
    return isJpgOrPng && isLt2M;
}


class EmpresaDrawer extends Component {
    state = {
        visible: false,
        carregouDados: false,
        registro: {
            par_flag_impr_ped_sem_descon: 0,
            par_entrega_itens_vendas: 0,
            par_exportar_orcamentos: 0,
            par_flag_grade_produtos: 0,

            par_status_padrao_pedido: 0,
            par_dias_sinc_ped_cel: 0,

            par_modelo_pedido_A4: '',
            par_modelo_pedido_cupom: '',
            par_modelo_orcamento_A4: '',
            par_modelo_orcamento_cupom: '',

            base64_pedido_A4: '',
            base64_pedido_cupom: '',
            base64_orcamento_A4: '',
            base64_orcamento_cupom: '',

            pathImagem_pedido_A4: null,
            pathImagem_pedido_cupom: null,
            pathImagem_orcamento_A4: null,
            pathImagem_orcamento_cupom: null,
        },
    }

    componentDidUpdate(propsAnte, stateAnte) {
        if ((this.state.visible) && (!this.state.carregouDados)) {
            this.setState({
                carregouDados: true,
                registro: {
                    par_flag_impr_ped_sem_descon: 0,
                    par_entrega_itens_vendas: 0,
                    par_exportar_orcamentos: 0,
                    par_flag_grade_produtos: 0,

                    par_status_padrao_pedido: 0,
                    par_dias_sinc_ped_cel: 0,

                    par_modelo_pedido_A4: '',
                    par_modelo_pedido_cupom: '',
                    par_modelo_orcamento_A4: '',
                    par_modelo_orcamento_cupom: '',

                    base64_pedido_A4: '',
                    base64_pedido_cupom: '',
                    base64_orcamento_A4: '',
                    base64_orcamento_cupom: '',

                    pathImagem_pedido_A4: null,
                    pathImagem_pedido_cupom: null,
                    pathImagem_orcamento_A4: null,
                    pathImagem_orcamento_cupom: null,
                },
            }, () => {
                this.onBuscaParametros()
                this.buscaStatus()
            });

        }
    }

    componentDidMount() {
        // const usuario = getUsuario();
        // this.setState({
        //     usuario,
        // });
    }

    showDrawer = () => {
        this.setState({
            visible: true,
            carregouDados: false,
        });
    };

    onClose = () => {
        this.setState({
            visible: false,
            carregouDados: false,
            registro: {
                par_flag_impr_ped_sem_descon: 0,
                par_entrega_itens_vendas: 0,
                par_exportar_orcamentos: 0,
                par_flag_grade_produtos: 0,

                par_status_padrao_pedido: 0,
                par_dias_sinc_ped_cel: 0,

                par_modelo_pedido_A4: '',
                par_modelo_pedido_cupom: '',
                par_modelo_orcamento_A4: '',
                par_modelo_orcamento_cupom: '',

                base64_pedido_A4: '',
                base64_pedido_cupom: '',
                base64_orcamento_A4: '',
                base64_orcamento_cupom: '',

                pathImagem_pedido_A4: null,
                pathImagem_pedido_cupom: null,
                pathImagem_orcamento_A4: null,
                pathImagem_orcamento_cupom: null,
            },
        });
    };

    onSalvarClick = () => {
        this.setState({ salvando: true })

        const registro = {
            ...this.state.registro,
            par_status_padrao_pedido: this.state.registro.par_status_padrao_pedido && this.state.registro.par_status_padrao_pedido.key ? this.state.registro.par_status_padrao_pedido.key : '',
        };

        // console.log('onSalvarClick: ', registro);

        axios
            .put('/parametros/update', registro)
            .then(response => {
                this.onClose();
                message.success('Configurações gravada com sucesso.');
            })
            .catch(error => {
                console.error(error.response);
                this.setState({
                    salvando: false
                })
                Modal.error({ title: 'Erro Inesperado', content: 'Não foi possível salvar. ' + error.response.data, okText: 'OK', })
            })
    }


    onBuscaParametros = registro => {
        this.setState({ carregando: true });
        axios.get(`/parametros/getPararametros`)
            .then(response => {
                const { data } = response;

                // console.log('onBuscaParametros: ', data);

                data.par_status_padrao_pedido = {
                    key: data.par_status_padrao_pedido ? String(data.par_status_padrao_pedido) : "0",
                    label: data.par_status_padrao_pedido ? data.sv_descricao : "",
                }

                data.pathImagem_pedido_A4 = data.par_modelo_pedido_A4 ? resolveImageUrl(`emp${data.prod_empresa}/produtos/${data.par_modelo_pedido_A4}`) : '';
                data.pathImagem_pedido_cupom = data.par_modelo_pedido_cupom ? resolveImageUrl(`emp${data.prod_empresa}/produtos/${data.par_modelo_pedido_cupom}`) : '';
                data.pathImagem_orcamento_A4 = data.par_modelo_orcamento_A4 ? resolveImageUrl(`emp${data.prod_empresa}/produtos/${data.par_modelo_orcamento_A4}`) : '';
                data.pathImagem_orcamento_cupom = data.par_modelo_orcamento_cupom ? resolveImageUrl(`emp${data.prod_empresa}/produtos/${data.par_modelo_orcamento_cupom}`) : '';

                this.setState({
                    registro: data,
                    carregando: false,
                })
            })
            .catch(error => {
                console.error(error.response);
                this.setState({
                    carregando: false,
                })
            })
    };

    buscaStatus = (value) => {
        this.setState({ statusSelect: [] })
        axios.get('/statusVenda/lista', {
        }).then(response => {
            const { data } = response;
            const statusSelect = data.map(regList => {
                return {
                    key: regList.sv_idf,
                    label: regList.sv_descricao,
                }
            });
            this.setState({
                statusSelect,
            })
        }).catch(error => {
            console.error(error.response);
        })
    }

    onChange = event => {
        const value = event.target.value;
        const id = event.target.id;
        const { registro } = this.state;
        registro[id] = value;
        this.setState({ [id]: value });
    };

    onChangeStatus = event => {
        const { registro } = this.state;
        registro['par_status_padrao_pedido'] = event.par_status_padrao_pedido;
        this.setState(registro);
    }




    handleChangePedidoA4 = info => {
        // console.log('handleChangePedidoA4: ', info);

        const isJpgOrPng = info.file.type === 'text/html';
        if (!isJpgOrPng) {
            return;
        }
        const isLt2M = info.file.size / 1024 / 1024 < 0.1;
        if (!isLt2M) {
            return;
        }

        this.setState({
            registro: {
                ...this.state.registro,
                imgNomePedidoA4: '',
                imgSizePedidoA4: '',
                imgDataPedidoA4: '',
                pathImagem_pedido_A4: '',
                base64_pedido_A4: '',
            },
        });

        getBase64(info.file.originFileObj, imageUrl =>
            this.setState({
                registro: {
                    ...this.state.registro,
                    imgNomePedidoA4: info.file.name,
                    imgSizePedidoA4: info.file.size,
                    imgDataPedidoA4: info.file.lastModifiedDate,
                    pathImagem_pedido_A4: '',
                    base64_pedido_A4: imageUrl,
                },
                loading: false,
            }),
        );
    };


    handleChangePedidoCupom = info => {
        // console.log('handleChangePedidoCupom: ', info);

        const isJpgOrPng = info.file.type === 'text/html';
        if (!isJpgOrPng) {
            return;
        }
        const isLt2M = info.file.size / 1024 / 1024 < 0.1;
        if (!isLt2M) {
            return;
        }

        this.setState({
            registro: {
                ...this.state.registro,
                imgNomePedidoCupom: '',
                imgSizePedidoCupom: '',
                imgDataPedidoCupom: '',
                pathImagem_pedido_cupom: '',
                base64_pedido_cupom: '',
            },
        });

        getBase64(info.file.originFileObj, imageUrl =>
            this.setState({
                registro: {
                    ...this.state.registro,
                    imgNomePedidoCupom: info.file.name,
                    imgSizePedidoCupom: info.file.size,
                    imgDataPedidoCupom: info.file.lastModifiedDate,
                    pathImagem_pedido_cupom: '',
                    base64_pedido_cupom: imageUrl,
                },
                loading: false,
            }),
        );
    };


    handleChangeOrcamentoA4 = info => {
        // console.log('handleChangeOrcamentoA4: ', info);

        const isJpgOrPng = info.file.type === 'text/html';
        if (!isJpgOrPng) {
            return;
        }
        const isLt2M = info.file.size / 1024 / 1024 < 0.1;
        if (!isLt2M) {
            return;
        }

        this.setState({
            registro: {
                ...this.state.registro,
                imgNomeOrcamentoA4: '',
                imgSizeOrcamentoA4: '',
                imgDataOrcamentoA4: '',
                pathImagem_orcamento_A4: '',
                base64_orcamento_A4: '',
            },
        });

        getBase64(info.file.originFileObj, imageUrl =>
            this.setState({
                registro: {
                    ...this.state.registro,
                    imgNomeOrcamentoA4: info.file.name,
                    imgSizeOrcamentoA4: info.file.size,
                    imgDataOrcamentoA4: info.file.lastModifiedDate,
                    pathImagem_orcamento_A4: '',
                    base64_orcamento_A4: imageUrl,
                },
                loading: false,
            }),
        );
    };


    handleChangeOrcamentoCupom = info => {
        // console.log('handleChangeOrcamentoCupom: ', info);

        const isJpgOrPng = info.file.type === 'text/html';
        if (!isJpgOrPng) {
            return;
        }
        const isLt2M = info.file.size / 1024 / 1024 < 0.1;
        if (!isLt2M) {
            return;
        }

        this.setState({
            registro: {
                ...this.state.registro,
                imgNomeOrcamentoCupom: '',
                imgSizeOrcamentoCupom: '',
                imgDataOrcamentoCupom: '',
                pathImagem_orcamento_cupom: '',
                base64_orcamento_cupom: '',
            },
        });

        getBase64(info.file.originFileObj, imageUrl =>
            this.setState({
                registro: {
                    ...this.state.registro,
                    imgNomeOrcamentoCupom: info.file.name,
                    imgSizeOrcamentoCupom: info.file.size,
                    imgDataOrcamentoCupom: info.file.lastModifiedDate,
                    pathImagem_orcamento_cupom: '',
                    base64_orcamento_cupom: imageUrl,
                },
                loading: false,
            }),
        );
    };







    onRemoveImagePedidoA4 = (file) => {
        const { confirm } = Modal
        return new Promise((resolve, reject) => {
            confirm({
                title: 'Deseja Excluir o Modelo?',
                onOk: () => {
                    resolve(true)
                    this.setState({
                        registro: {
                            ...this.state.registro,
                            imgNomePedidoA4: '',
                            imgSizePedidoA4: '',
                            imgDataPedidoA4: '',
                            pathImagem_pedido_A4: '',
                            base64_pedido_A4: '',
                        },
                    });
                },
                onCancel: () => {
                    reject(true)
                }
            })
        })
    }

    onRemoveImagePedidoCupom = (file) => {
        const { confirm } = Modal
        return new Promise((resolve, reject) => {
            confirm({
                title: 'Deseja Excluir o Modelo?',
                onOk: () => {
                    resolve(true)
                    this.setState({
                        registro: {
                            ...this.state.registro,
                            imgNomePedidoCupom: '',
                            imgSizePedidoCupom: '',
                            imgDataPedidoCupom: '',
                            pathImagem_pedido_cupom: '',
                            base64_pedido_cupom: '',
                        },
                    });
                },
                onCancel: () => {
                    reject(true)
                }
            })
        })
    }

    onRemoveImageOrcamentoA4 = (file) => {
        const { confirm } = Modal
        return new Promise((resolve, reject) => {
            confirm({
                title: 'Deseja Excluir o Modelo?',
                onOk: () => {
                    resolve(true)
                    this.setState({
                        registro: {
                            ...this.state.registro,
                            imgNomeOrcamentoA4: '',
                            imgSizeOrcamentoA4: '',
                            imgDataOrcamentoA4: '',
                            pathImagem_orcamento_A4: '',
                            base64_orcamento_A4: '',
                        },
                    });
                },
                onCancel: () => {
                    reject(true)
                }
            })
        })
    }

    onRemoveImageOrcamentoCupom = (file) => {
        const { confirm } = Modal
        return new Promise((resolve, reject) => {
            confirm({
                title: 'Deseja Excluir o Modelo?',
                onOk: () => {
                    resolve(true)
                    this.setState({
                        registro: {
                            ...this.state.registro,
                            imgNomeOrcamentoCupom: '',
                            imgSizeOrcamentoCupom: '',
                            imgDataOrcamentoCupom: '',
                            pathImagem_orcamento_cupom: '',
                            base64_orcamento_cupom: '',
                        },
                    });
                },
                onCancel: () => {
                    reject(true)
                }
            })
        })
    }



    render() {
        const { placement, visible, gravando, carregando } = this.state;
        const { par_entrega_itens_vendas, par_flag_impr_ped_sem_descon, par_exportar_orcamentos, par_flag_grade_produtos,
            par_dias_sinc_ped_cel, par_status_padrao_pedido,
            base64_pedido_A4, pathImagem_pedido_A4, base64_pedido_cupom, pathImagem_pedido_cupom,
            base64_orcamento_A4, pathImagem_orcamento_A4, base64_orcamento_cupom, pathImagem_orcamento_cupom,
        } = this.state.registro;

        const uploadButton = (
            <div>
                {this.state.loading ? <Icon type="loading" style={{ color: 'rgba(0,0,0,0.4)' }} /> : <Icon type="plus" style={{ color: 'rgba(0,0,0,0.4)' }} />}
                <div className="ant-upload-text">Logo</div>
            </div>
        );

        // console.log('ParametrosDrawer.state: ', this.state);

        return (
            <div>
                <Tooltip title="Configurações" placement="bottomLeft">
                    <span style={{ cursor: 'pointer' }} onClick={this.showDrawer}>
                        <Icon type="setting" />
                    </span>
                </Tooltip>

                <Drawer
                    title="Configurações"
                    placement={placement}
                    closable={false}
                    onClose={this.onClose}
                    visible={visible}
                    key={placement}
                    width={"35%"}
                >
                    <Tooltip title="Fechar">
                        <span style={{ fontSize: 20, color: Colors.accentLight, float: "right", marginTop: -70, marginRight: 20, cursor: 'pointer' }} onClick={this.onClose}>
                            <Icon type="close" />
                        </span>
                    </Tooltip>


                    <div className="card-container" style={{ minHeight: 0 }}>
                        <Row>

                            <Col xs={13} style={{ marginTop: 0 }}>
                                <span>Status padrão dos pedidos</span>
                                <InputForm
                                    // label="Status padrão dos pedidos"
                                    type="select"
                                    id="par_status_padrao_pedido"
                                    ref="par_status_padrao_pedido"
                                    value={par_status_padrao_pedido}
                                    placeholder="Status da Venda"
                                    onChange={this.onChange}
                                    data={this.state.statusSelect}
                                    validator={value => Boolean(value)}
                                    style={{ width: "100%" }}
                                />
                            </Col>

                            <Col xs={13} style={{ marginTop: -20 }}>
                                <span>Qtde dias para importar os pedidos no celular</span>
                                <InputForm
                                    type="number"
                                    id="par_dias_sinc_ped_cel"
                                    ref="par_dias_sinc_ped_cel"
                                    value={par_dias_sinc_ped_cel}
                                    decimalScale={0}
                                    onChange={this.onChange}
                                />
                            </Col>

                            <Divider />

                            <Col xs={24} style={{ marginTop: 0, marginBottom: 0 }}>
                                <InputForm
                                    type="checkbox"
                                    id="par_entrega_itens_vendas"
                                    ref="par_entrega_itens_vendas"
                                    onChange={this.onChange}
                                    value={par_entrega_itens_vendas}
                                >
                                    Controla Entrega dos Produtos
                                </InputForm>
                            </Col>

                            <Col xs={24} style={{ marginTop: -30, marginBottom: 0 }}>
                                <InputForm
                                    type="checkbox"
                                    id="par_flag_impr_ped_sem_descon"
                                    ref="par_flag_impr_ped_sem_descon"
                                    onChange={this.onChange}
                                    value={par_flag_impr_ped_sem_descon}
                                >
                                    Imprime Pedido sem Desconto
                                </InputForm>
                            </Col>

                            <Col xs={24} style={{ marginTop: -30, marginBottom: 0 }}>
                                <InputForm
                                    type="checkbox"
                                    id="par_exportar_orcamentos"
                                    ref="par_exportar_orcamentos"
                                    onChange={this.onChange}
                                    value={par_exportar_orcamentos}
                                >
                                    Exportar Orçamentos
                                </InputForm>
                            </Col>

                            <Col xs={24} style={{ marginTop: -30, marginBottom: 0 }}>
                                <InputForm
                                    type="checkbox"
                                    id="par_flag_grade_produtos"
                                    ref="par_flag_grade_produtos"
                                    onChange={this.onChange}
                                    value={par_flag_grade_produtos}
                                >
                                    Utilizar Grade de Produtos
                                </InputForm>
                            </Col>

                            <Divider />

                            <Col xs={24} sm={6} style={{ marginTop: 0, marginBottom: 10 }}>
                                <Tooltip title="Carregar Modelo Pedido A4" placement="topLeft">
                                    <span style={{}}>
                                        <Upload
                                            name="avatar"
                                            listType="picture-card"
                                            // className="avatar-uploader"
                                            showUploadList={false}
                                            beforeUpload={beforeUpload}
                                            onChange={this.handleChangePedidoA4}
                                            style={{ backgroundColor: base64_pedido_A4 || pathImagem_pedido_A4 ? Colors.primary : Colors.background }}
                                        >
                                            <span style={{}}>
                                                MODELO PEDIDO A4
                                            </span>
                                        </Upload>
                                    </span>
                                </Tooltip>
                                {base64_pedido_A4 || pathImagem_pedido_A4 ? (
                                    <Col xs={24} style={{ marginTop: -40 }}>
                                        <Tooltip title="Excluir Modelo" placement="right">
                                            <Button
                                                type="ghost"
                                                htmlType="button"
                                                loading={carregando}
                                                onClick={this.onRemoveImagePedidoA4}
                                                icon="delete"
                                                className="botoesModalFormExcluir"
                                            ></Button>
                                        </Tooltip>
                                    </Col>
                                ) : null}
                            </Col>

                            <Col xs={24} sm={6} style={{ marginTop: 0, marginBottom: 10 }}>
                                <Tooltip title="Carregar Modelo Pedido Cupom" placement="topLeft">
                                    <span style={{}}>
                                        <Upload
                                            name="avatar"
                                            listType="picture-card"
                                            // className="avatar-uploader"
                                            showUploadList={false}
                                            beforeUpload={beforeUpload}
                                            onChange={this.handleChangePedidoCupom}
                                            style={{ backgroundColor: base64_pedido_cupom || pathImagem_pedido_cupom ? Colors.primary : Colors.background }}
                                        >
                                            <span style={{}}>
                                                MODELO PEDIDO CUPOM
                                            </span>
                                        </Upload>
                                    </span>
                                </Tooltip>
                                {base64_pedido_cupom || pathImagem_pedido_cupom ? (
                                    <Col xs={24} style={{ marginTop: -40 }}>
                                        <Tooltip title="Excluir Modelo" placement="right">
                                            <Button
                                                type="ghost"
                                                htmlType="button"
                                                loading={carregando}
                                                onClick={this.onRemoveImagePedidoCupom}
                                                icon="delete"
                                                className="botoesModalFormExcluir"
                                            ></Button>
                                        </Tooltip>
                                    </Col>
                                ) : null}
                            </Col>

                            <Col xs={24} sm={6} style={{ marginTop: 0, marginBottom: 10 }}>
                                <Tooltip title="Carregar Modelo Orçamento A4" placement="topLeft">
                                    <span style={{}}>
                                        <Upload
                                            name="avatar"
                                            listType="picture-card"
                                            // className="avatar-uploader"
                                            showUploadList={false}
                                            beforeUpload={beforeUpload}
                                            onChange={this.handleChangeOrcamentoA4}
                                            style={{ backgroundColor: base64_orcamento_A4 || pathImagem_orcamento_A4 ? Colors.primary : Colors.background }}
                                        >
                                            <span style={{}}>
                                                MODELO ORÇAMENTO A4
                                            </span>
                                        </Upload>
                                    </span>
                                </Tooltip>
                                {base64_orcamento_A4 || pathImagem_orcamento_A4 ? (
                                    <Col xs={24} style={{ marginTop: -40 }}>
                                        <Tooltip title="Excluir Modelo" placement="right">
                                            <Button
                                                type="ghost"
                                                htmlType="button"
                                                loading={carregando}
                                                onClick={this.onRemoveImageOrcamentoA4}
                                                icon="delete"
                                                className="botoesModalFormExcluir"
                                            ></Button>
                                        </Tooltip>
                                    </Col>
                                ) : null}
                            </Col>

                            <Col xs={24} sm={6} style={{ marginTop: 0, marginBottom: 10 }}>
                                <Tooltip title="Carregar Modelo Orçamento Cupom" placement="topLeft">
                                    <span style={{}}>
                                        <Upload
                                            name="avatar"
                                            listType="picture-card"
                                            // className="avatar-uploader"
                                            showUploadList={false}
                                            beforeUpload={beforeUpload}
                                            onChange={this.handleChangeOrcamentoCupom}
                                            style={{ backgroundColor: base64_orcamento_cupom || pathImagem_orcamento_cupom ? Colors.primary : Colors.background }}
                                        >
                                            <span style={{}}>
                                                MODELO ORÇAMENTO CUPOM
                                            </span>
                                        </Upload>
                                    </span>
                                </Tooltip>
                                {base64_orcamento_cupom || pathImagem_orcamento_cupom ? (
                                    <Col xs={24} style={{ marginTop: -40 }}>
                                        <Tooltip title="Excluir Modelo" placement="right">
                                            <Button
                                                type="ghost"
                                                htmlType="button"
                                                loading={carregando}
                                                onClick={this.onRemoveImageOrcamentoCupom}
                                                icon="delete"
                                                className="botoesModalFormExcluir"
                                            ></Button>
                                        </Tooltip>
                                    </Col>
                                ) : null}
                            </Col>

                        </Row>
                    </div>


                    <div>
                        <div className="divider-form" />
                        <ItemForm>
                            <Row>
                                <Col xs={24}>
                                    <Button
                                        htmlType="button"
                                        loading={gravando}
                                        onClick={this.onSalvarClick}
                                        className="botoesModalForm"
                                    >
                                        Salvar
                                    </Button>

                                    <Button
                                        htmlType="button"
                                        onClick={this.onClose}
                                        className="botoesModalFecharForm"
                                    >
                                        Fechar
                                    </Button>
                                </Col>
                            </Row>
                        </ItemForm>
                    </div>

                </Drawer>
            </div >
        );
    }
}

export default EmpresaDrawer;



// WEBPACK FOOTER //
// ./src/components/ParametrosDrawer.js